/* eslint-disable no-underscore-dangle */
import Amplify from 'aws-amplify';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import 'react-toastify/dist/ReactToastify.css';

import { store, persistor } from 'store/store';

import awsConfig from './aws-exports';
import './assets/fonts/stylesheet.css';
import ThemeProviderWrapper from 'components/ThemeProvider';

Amplify.configure(awsConfig);

declare global {
  interface Window {
    _paq: any[];
    _mtm: any[];
  }
}

const matomoUrl = process.env.REACT_APP_MATOMO_URL!;
const matomoSiteId = process.env.REACT_APP_MATOMO_SITEID!;
const matomoTagManagerId = process.env.REACT_APP_MATOMO_TAGMANAGER_ID!;

// Add Matomo tracking in production
if (matomoUrl && matomoSiteId) {
  window._paq = window._paq || [];

  // Configure BEFORE loading the script
  window._paq.push(['setTrackerUrl', matomoUrl + 'matomo.php']);
  window._paq.push(['setSiteId', matomoSiteId]);
  window._paq.push(['enableLinkTracking']);
  window._paq.push(['trackPageView']);

  const script = document.createElement('script');
  script.async = true;
  script.src = matomoUrl + 'matomo.js';
  document.head.appendChild(script);

  // Matomo Tag Manager script
  if (matomoTagManagerId) {
    window._mtm = window._mtm || [];
    window._mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' });

    const script2 = document.createElement('script');
    script2.async = true;
    script2.src = `${matomoUrl}/js/container_${matomoTagManagerId}.js`;

    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      console.warn('Matomo script insertion failed.');
    }
  }
}

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProviderWrapper />
    </PersistGate>
  </Provider>
);

export default App;
